import { isDarkMode } from '@bubble-ui/particle-design-versions';
export var getDefaultStyleSheet = _ref => {
  var {
    designVersion,
    designContext
  } = _ref;
  var borderRadius = designContext.get('context-menu/corner-radius').pixelValue;
  return {
    rootStyle: {
      backgroundColor: designContext.get('colors/backgrounds/default').toString(),
      borderRadius,
      boxShadow: "".concat(isDarkMode(designVersion) ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.15)', " 0 3px 15px 0px"),
      maxWidth: 360,
      paddingBottom: 15,
      paddingTop: 15
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map